import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import store from "./store/store.js";
import App from "./App";
import Notifier from "components/UI/notifications/Notifier";
import { SnackbarProvider } from "notistack";
import { FormControlerContextProvider } from "./store/form-controler-context/form-controler-context";
import { BrowserRouter } from "react-router-dom";
import { AuthContextProvider } from "store/auth-context/auth-context";
import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ErrorBoundary>
      <SnackbarProvider
        maxSnack={15}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        preventDuplicate={true}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <FormControlerContextProvider>
            <BrowserRouter>
              <AuthContextProvider>
                <App />
                <Notifier />
              </AuthContextProvider>
            </BrowserRouter>
          </FormControlerContextProvider>
        </LocalizationProvider>
      </SnackbarProvider>
    </ErrorBoundary>
  </Provider>
  // </React.StrictMode>
);
